import { useId } from 'react'

import { StoryRelevantStoriesCollection, Story } from '@/interfaces/schema'
import StoryCardWithImage from '@/components/cards/stories/with-image'
import Section from '@/layouts/section'
import { GRID } from '@/lib/constants'
import { StoryCardWithImgPosition } from '@/interfaces/stories'
import { routes } from '@/lib/constants'
import useIsRay from '@/hooks/useIsRay'

const RelatedArticles = ({
  relevantStoriesCollection,
}: {
  relevantStoriesCollection: StoryRelevantStoriesCollection
}) => {
  const id = useId()
  const isRay = useIsRay()

  return (
    <Section className={`${GRID}`}>
      {relevantStoriesCollection?.items?.map((story: Story, index: number) => {
        const { title, slug, image, description } = story
        const publicationDate = story.publicationDate as Date
        const buttonLink = `${
          isRay
            ? routes.ray.knowledgeAndInspiration
            : routes.rvdb.knowledgeAndInspiration
        }/${slug}`

        return (
          <StoryCardWithImage
            imgPosition={StoryCardWithImgPosition.TOP}
            className="col-span-full md:col-span-3 lg:col-span-4"
            key={`${id}--${index}`}
            title={title}
            publicationDate={publicationDate}
            buttonText="Lees meer"
            buttonLink={buttonLink}
            image={image}
            description={description}
          />
        )
      })}
    </Section>
  )
}

export default RelatedArticles
